import { render, staticRenderFns } from "./TagComponent.vue?vue&type=template&id=17b0b848"
import script from "./TagComponent.vue?vue&type=script&lang=js"
export * from "./TagComponent.vue?vue&type=script&lang=js"
import style0 from "./TagComponent.vue?vue&type=style&index=0&id=17b0b848&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports